export default class Readmore {
  constructor({ containerElement, childrenSelector, toggleButtonClass }) {
    this.containerElement = containerElement
    this.toggleItemElements = containerElement.querySelectorAll(
      childrenSelector
    )
    this.toggleButtonElement = this.createReadMoreButton()
    this.toggleButtonClass = toggleButtonClass

    if (this.containerElement && this.toggleItemElements.length) {
      this.hideListItemExpectFirst()
      this.addReadMoreButton()
    }
  }

  createReadMoreButton() {
    const addButtonElement = document.createElement('button')
    addButtonElement.innerText = 'もっと読む'
    addButtonElement.classList.add(this.toggleButtonClass)
    addButtonElement.onclick = () => this.handleClickReadMore()
    return addButtonElement
  }

  handleClickReadMore() {
    this.toggleItemElements.forEach(Readmore.toggleElement)
    this.containerElement.querySelector(`.${this.toggleButtonClass}`).remove()
  }

  addReadMoreButton() {
    const readMoreButton = this.createReadMoreButton()
    this.containerElement.append(readMoreButton)
  }

  hideListItemExpectFirst() {
    this.toggleItemElements.forEach(Readmore.hideElement)
  }

  static hideElement(elememt) {
    elememt.style.display = 'none'
  }

  static toggleElement(elememt) {
    if (elememt.style.display === 'none') {
      elememt.style.display = 'list-item'
    } else {
      Readmore.hideElement(elememt)
    }
  }

  static makeAll({ containerSelector, childrenSelector, toggleButtonClass }) {
    document.querySelectorAll(containerSelector).forEach(containerElement => {
      new Readmore({
        containerElement,
        childrenSelector,
        toggleButtonClass,
      })
    })
  }
}
